<template>
  <div>
    <CRow>
      <CCol md="12" lg="12" sm="12" xs="12" class="float-right">
        <button @click="mtdBack" type="button" class="btn btn-sm text-white float-right" style="background: #E46666">
          <i class="fas fa-hand-point-left"></i> Ir a Inicio
        </button>
      </CCol>
    </CRow>
    <CRow>
      <div id="div_conte" class="col-md-10 mx-auto">
        <div class="bg-secondary text-white bg-opacity-10">
          <div class="text-center py-4 px-5" id="scroll-div">
            <div v-for="(buttonGroup, index) in groupedButtons" :key="index" class="row">
              <button v-for="(button, idx) in buttonGroup" :key="idx" class="div-button col m-2 p-2 text-white"
                @click="changePage(button.page)">
                {{ button.label }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </CRow>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "home",
  props: {
  },
  created() {
    this.showBead();
  },
  data() {
    return {
      buttons: [
        { label: "COBRO COMANDA", page: "comand" },
        { label: "COMPRA", page: "purchase" },
        { label: "VENTA", page: "sale" },
        { label: "VER STOCK", page: "stock" },
        { label: "KARDEX", page: "kardex" },
        { label: "MOV. STOCK", page: "mov_stock" },
        { label: "CXC", page: "cxc" },
        { label: "CANCEL. VOUCHER", page: "cancel_voucher" }
      ],
      verificBead: false
    };
  },
  computed: {
    filteredButtons() {
        return this.buttons;
    },
    groupedButtons() {
      const groups = [];
      for (let i = 0; i < this.filteredButtons.length; i += 4) {
        groups.push(this.filteredButtons.slice(i, i + 4));
      }
      return groups;
    }
  },
  methods: {
    ...mapActions(["get", "post"]),
    changePage: function (page) {
      if ((page == "sale" || page == "cxc" || page == "cancel_voucher") && !this.verificBead) {
        Swal.fire({
          title: "No hay caja aperturada",
          icon: "warning",
        });
      } else {
        this.$emit("changePage", page);
      }
    },
    hasRoles(roles) {
      return roles.some((role) => this.userRoles.includes(role));
    },
    showBead() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/beads/showBead/" +
          this.$store.getters.get_campu.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.verificBead = response.data ? true : false;
          }
        })
        .catch((errors) => { });
    },
    getCompany() {
      return this.$store.getters.get_company.name;
    },
    getCampu() {
      return this.$store.getters.get_campu.name;
    },
    mtdBack() {
      this.$emit('setView', 'home')
    },
  },
};
</script>

<style scoped>
#div_conte {
  border: 1.5px solid #926cdc;
  padding: 0;
  margin: 40px 0;
}

.div-button {
  background: #926cdc;
  border-radius: 15px;
  border: none;
}

#scroll-div {
  height: auto;
  overflow-y: scroll;
}

#scroll-div>div>button {
  height: 65px;
}

@media (max-width: 1320px) {
  #div_conte {
    border: 1.5px solid #926cdc;
    padding: 0;
    margin: 60px 0;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {

  #div_conte {
    border: 1.5px solid #926cdc;
    padding: 0;
    margin: 100px 0;
  }

  #scroll-div {
    height: 518px;
  }
}

@media (max-width: 768px) {
  #scroll-div>div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  #scroll-div>div>button {
    height: 44px;
    width: 100%;
    margin: 5px 0;
  }

  .container {
    font-size: 11px;
  }

  #scroll-div {
    height: 450px;
  }
}

@media (max-width: 415px) {
  #scroll-div>div>button {
    height: 40px;
    font-size: 12px;
  }
}
</style>
